
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ContactInfo from './components/ContactInfo';
import InquiryForm from './components/InquiryForm';
import MapSection from './components/MapSection';

export default function ContactPage() {
  // Scroll to top when the page mounts
  useEffect(() => {
    try {
      window.scrollTo(0, 0);
    } catch (err) {
      console.error('Failed to scroll to top:', err);
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#F8FAFB]" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      <Hero />

      {/* Main Content: Info + Form */}
      <section className="py-14 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
            {/* Left: Contact Info */}
            <div className="lg:col-span-2">
              <ContactInfo />
            </div>
            {/* Right: Inquiry Form */}
            <div className="lg:col-span-3">
              <InquiryForm />
            </div>
          </div>
        </div>
      </section>

      <MapSection />

      {/* Footer */}
      <footer className="bg-[#1A2332] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 py-10 sm:py-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div>
              <div className="flex items-center space-x-3 mb-5">
                <div className="w-10 h-10 rounded-lg bg-[#0066CC] flex items-center justify-center">
                  <i className="ri-code-s-slash-line text-xl text-white"></i>
                </div>
              </div>
              <p className="text-gray-400 leading-relaxed text-sm">
                Leading IT services provider delivering innovative defense technology solutions.
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-5">
                Quick Links
              </h4>
              <ul className="space-y-3">
                {[
                  { label: 'Home', href: '/' },
                  { label: 'About Us', href: '/about' },
                  { label: 'Careers', href: '/careers' },
                  { label: 'Contact', href: '/contact' },
                ].map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-white hover:text-[#0066CC] transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-5">
                Services
              </h4>
              <ul className="space-y-3">
                {['Cloud Solutions', 'Cybersecurity', 'AI & Analytics', 'IT Consulting'].map(
                  (service) => (
                    <li key={service}>
                      <a
                        href="/#services"
                        className="text-sm text-white hover:text-[#0066CC] transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {service}
                      </a>
                    </li>
                  )
                )}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-5">
                Connect
              </h4>
              <ul className="space-y-3">
                {[
                  { icon: 'ri-linkedin-fill', name: 'LinkedIn' },
                  { icon: 'ri-twitter-x-fill', name: 'Twitter' },
                  { icon: 'ri-facebook-fill', name: 'Facebook' },
                  { icon: 'ri-youtube-fill', name: 'YouTube' },
                ].map((social) => (
                  <li key={social.name}>
                    <a
                      href="#"
                      rel="nofollow"
                      className="flex items-center text-white hover:text-[#0066CC] transition-colors text-sm cursor-pointer whitespace-nowrap"
                    >
                      <i className={`${social.icon} text-lg mr-3`}></i>
                      {social.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-700 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs sm:text-sm text-gray-400">
              © 2026 Patriot Defense Technologies LLC. All rights reserved.
            </p>
            <div className="flex items-center gap-4 sm:gap-6 flex-wrap justify-center">
              <a
                href="#"
                className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors whitespace-nowrap"
              >
                Privacy Policy
              </a>
              <a
                href="#"
                className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors whitespace-nowrap"
              >
                Terms of Service
              </a>
              <a
                href="https://readdy.ai/?ref=logo"
                rel="nofollow"
                className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors whitespace-nowrap"
              >
                Web Design
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
